import React from "react";
import Header from "../../Header/Header";
import banner from "../../Assets/cover.png";
import { useLocation, useNavigate } from "react-router-dom";
import LoginModal from "../../Modals/LoginModal.js";
import experienceImg from "../../Assets/experienceImg.png"
import differently from "../../Assets/differently.png"
import axiosConfig from "../../../Service/AxiosConfig.js"
import quote from "../../Assets/icon.png";
import CoverHero from "../CoverHero";
import Slider from "react-slick";
import Testimonials from "../../Testimonial/Testimonial.jsx";
import Footer from "../../Footer/Footer";
import ServicesGrid from "../ServiceGrid";
import "./homeNurse.css";
import "./homenursedata.js"
import ServiceShowcase from "../ServiceShowCase.jsx";
import { useState, useEffect } from "react";
import {
  recoveryItems,  testimonialData, truncateLetters, settings, settings2, hospitals
  , experienceData, expertCareData, weDoItDifferentlyData, healedtitle, leadingtitle, whychoosetitle,
  recoverycontainerh2, serviceShowcaseData, whyCards, whyHeading
} from "./homenursedata.js";
import CardsContainer from "../CardsContainer.jsx";

function HomeNurse() {

   const navigate = useNavigate();
 
 
  return (
    <>
      <Header />
      <CoverHero image={banner} title="Home Nurse" />
      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="homenurse-servicewrapper"
            data={service}
             onServiceClick={() => navigate('/')}
          />
        ))}
      </div>
       

      <div className="texts-home-nurse">
        <h2>{expertCareData.heading}</h2>
        <p>{expertCareData.paragraph}</p>
      </div>

      <div className="recovery-container">
        <h2 >{recoverycontainerh2}</h2>
        <div className="recovery-grid">
          {recoveryItems.map((item, index) => (
            <div className="recovery-card" key={index}>
              <img src={item.img} alt={item.title} />
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <CardsContainer
        heading={whyHeading}
        services={Object.values(whyCards)}
        className="why-choose"
      />

      <div className="experience">
        <div className="experience-inner">
          <img src={experienceImg} alt="image" />

          <div className="experience-text">
            <h2>{experienceData.heading}</h2>
            <p>{experienceData.paragraph}</p>
          </div>
        </div>
      </div>

      <div className="differently row">
        <div className="leftside col-md-6 col-12">
          <div className="texts">
            <h2>{weDoItDifferentlyData.heading}</h2>
            <p>{weDoItDifferentlyData.paragraph}</p>

            <ul>
              {weDoItDifferentlyData.list.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="rightside col-md-6 col-12">
          <img src={differently} alt="image" />
        </div>
      </div>
      <Testimonials
        data={testimonialData}
        textKey="desc"
        imgKey="userimg"
        nameKey="username"
        // settings={settings}
        className="physio-testimonials"
      />

      <div className="leading">
        <h2>{leadingtitle}</h2>

        <Slider {...settings2}>
          {hospitals.map((hospital, index) => (
            <div key={index} className="hospital-card">
              <img src={hospital.logo} alt={hospital.name} />
            </div>
          ))}
        </Slider>
      </div>

      <ServicesGrid title="Check Our Other Services" exclude="Home Nurse" />

      <Footer />

    </>
  );
}

export default HomeNurse;


